import { object, string } from "yup";

export const unlimitedPaymentLinkSchema = object({
  amount: string()
    .required("0 TL'den büyük bir tutar giriniz")
    .matches(
      /^(?!0,00|0$)\d{1,3}(?:\.\d{3})*(?:,\d{2})?$/,
      "0 TL'den büyük bir tutar giriniz"
    ),
  linkdesc: string()
    .max(100, "Açıklama en fazla 100 karakter içermelidir.")
});